import '../types/images';
import '../styles/mediaInit';
import Storage from '@/utils/wrappers/Storage';

Storage.setDriver(window.localStorage);
